import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { StaffWorkdayFormModal } from "../components/StaffWorkdayFormModal";
import { StaffWorkdayTable } from "../components/StaffWorkdayTable";
import { useStaffWorkdayStore } from "../store/staff-workday.store";

export function StaffWorkdayPage() {
	const { openCreateModal } = useStaffWorkdayStore();

	return (
		<div>
			<PageHeader
				title="Xodim ish kunlari"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={openCreateModal}
						id="staff-workday-create-btn"
					>
						Qo&apos;shish
					</Button>
				}
			/>
			<StaffWorkdayTable />
			<StaffWorkdayFormModal />
		</div>
	);
}
